export class AccountIDs {
    constructor(
        public accountId: number | null,
        public siteId: number | null,
        public groupId: number | null,
        public distributorId: number | null
    ) {
        
    }
}